import { useSharableState, view } from '@esui/core';
import { DemoPage, Section } from '../@demo/utils.js';
import { Formfield } from '../formfield/index.js';
import { Checkbox } from './index.js';

export const [CheckboxDemo] = view('checkbox-demo', {
  template() {
    const checked = useSharableState(false);
    const indeterminate = useSharableState(true);

    return DemoPage(
      Section(
        '',
        Checkbox(checked),

        Checkbox(checked),

        Checkbox(checked).indeterminate(indeterminate),

        Checkbox(checked).disabled(),

        Formfield(Checkbox(checked)).label('Check me')
      ),

      Section(
        '',
        Checkbox(checked),

        Checkbox(checked),

        Checkbox(checked).indeterminate(indeterminate),

        Checkbox(checked).disabled()
      )
        .theme({
          secondaryColor: '#ff2929',
          onSurfaceColor: 'white',
        })
        .style('--mdc-checkbox-unchecked-color', 'white')
        .style('--mdc-checkbox-disabled-color', '#adadad')
        .style('--mdc-checkbox-mark-color', '#363636')
        .style('background', 'black')
    );
  },
});
